import { api } from "assets/scripts/utilities/api-clients";

export const count = async (id) => {
  const response = await api.get(`/kam/purchase-orders/${id}/ent/count`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/purchase-orders", options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/kam/purchase-orders/${id}`);

  return response;
};

export const post = async (
  purchaseOrder,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.post(`/kam/purchase-orders`, purchaseOrder, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const put = async (
  purchaseOrder,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.put("/kam/purchase-orders", purchaseOrder, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};

export const upload = async (payload) => {
  const response = await api.post(
    "/kam/purchase-orders/upload",
    { ...payload, po_extraction: true },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response;
};

export const getFiles = async (options) => {
  const response = await api.get(
    `/kam/${options?.params?.po_id}/files`,
    options,
  );

  return response;
};

export const putStatus = async (purchaseOrder) => {
  const response = await api.put("/kam/purchase-orders/status", purchaseOrder);

  return response;
};

export const checkNumber = async (payload) => {
  const response = await api.post("/kam/purchase-orders/number", payload);

  return response;
};
export const putApproversPurchaseOrderStatus = async (
  po,
  { params: { showMessage = false, ...restParams } = {}, ...restOptions } = {},
) => {
  const response = await api.put("/seller/add-purchase-order-status", po, {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};
